import {
  FETCH_COMMUNITY_PROFILE_REQUEST,
  FETCH_COMMUNITY_PROFILE_SUCCESS,
  FETCH_COMMUNITY_PROFILE_FAILURE,
  UPDATE_COMMUNITY_PROFILE_REQUEST,
  UPDATE_COMMUNITY_PROFILE_SUCCESS,
  UPDATE_COMMUNITY_PROFILE_FAILURE,
  UPDATE_COMMUNITY_PROFILE_PIC_REQUEST,
  COMMUNITY_SET_IS_LOADING,
  FETCH_SUGGESTED_GROUPS_REQUEST,
  FETCH_SUGGESTED_GROUPS_SUCCESS,
  FETCH_SUGGESTED_GROUPS_FAILURE,
  FETCH_MY_GROUPS_REQUEST,
  FETCH_MY_GROUPS_SUCCESS,
  FETCH_MY_GROUPS_FAILURE,
  REMOVE_MY_GROUP,
  ADD_MY_GROUP,
  REMOVE_SUGGESTED_GROUP,
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  MARK_NOTIFICATION_READ_REQUEST,
  MARK_ALL_NOTIFICATIONS_READ_REQUEST,
  DELETE_NOTIFICATION_REQUEST,
  DELETE_ALL_NOTIFICATIONS_REQUEST,
  REMOVE_NOTIFICATION,
  UPDATE_NOTIFICATION_READ,
  UPDATE_ALL_NOTIFICATIONS_READ,
  CLEAR_ALL_NOTIFICATIONS,
} from '../../constant/community';

export const fetchCommunityProfileRequest = () => ({
  type: FETCH_COMMUNITY_PROFILE_REQUEST,
});

export const fetchCommunityProfileSuccess = payload => ({
  type: FETCH_COMMUNITY_PROFILE_SUCCESS,
  payload,
});

export const fetchCommunityProfileFailure = payload => ({
  type: FETCH_COMMUNITY_PROFILE_FAILURE,
  payload,
});

export const updateCommunityProfileRequest = payload => ({
  type: UPDATE_COMMUNITY_PROFILE_REQUEST,
  payload,
});

export const updateCommunityProfileSuccess = payload => ({
  type: UPDATE_COMMUNITY_PROFILE_SUCCESS,
  payload,
});

export const updateCommunityProfileFailure = payload => ({
  type: UPDATE_COMMUNITY_PROFILE_FAILURE,
  payload,
});

export const updateCommunityProfilePicRequest = payload => ({
  type: UPDATE_COMMUNITY_PROFILE_PIC_REQUEST,
  payload,
});

export const communitySetIsLoading = payload => ({
  type: COMMUNITY_SET_IS_LOADING,
  payload,
});

export const fetchSuggestedGroupsRequest = (page = 1) => ({
  type: FETCH_SUGGESTED_GROUPS_REQUEST,
  payload: { page },
});

export const fetchSuggestedGroupsSuccess = payload => ({
  type: FETCH_SUGGESTED_GROUPS_SUCCESS,
  payload,
});

export const fetchSuggestedGroupsFailure = payload => ({
  type: FETCH_SUGGESTED_GROUPS_FAILURE,
  payload,
});

export const fetchMyGroupsRequest = (page = 1) => ({
  type: FETCH_MY_GROUPS_REQUEST,
  payload: { page },
});

export const fetchMyGroupsSuccess = payload => ({
  type: FETCH_MY_GROUPS_SUCCESS,
  payload,
});

export const fetchMyGroupsFailure = payload => ({
  type: FETCH_MY_GROUPS_FAILURE,
  payload,
});

export const removeMyGroup = groupId => ({
  type: REMOVE_MY_GROUP,
  payload: groupId,
});

export const addMyGroup = group => ({
  type: ADD_MY_GROUP,
  payload: group,
});

export const removeSuggestedGroup = groupId => ({
  type: REMOVE_SUGGESTED_GROUP,
  payload: groupId,
});

export const fetchNotificationsRequest = (page = 1) => ({
  type: FETCH_NOTIFICATIONS_REQUEST,
  payload: { page },
});

export const fetchNotificationsSuccess = payload => ({
  type: FETCH_NOTIFICATIONS_SUCCESS,
  payload,
});

export const fetchNotificationsFailure = payload => ({
  type: FETCH_NOTIFICATIONS_FAILURE,
  payload,
});

export const markNotificationReadRequest = notificationId => ({
  type: MARK_NOTIFICATION_READ_REQUEST,
  payload: notificationId,
});

export const markAllNotificationsReadRequest = () => ({
  type: MARK_ALL_NOTIFICATIONS_READ_REQUEST,
});

export const deleteNotificationRequest = notificationId => ({
  type: DELETE_NOTIFICATION_REQUEST,
  payload: notificationId,
});

export const deleteAllNotificationsRequest = () => ({
  type: DELETE_ALL_NOTIFICATIONS_REQUEST,
});

export const removeNotification = notificationId => ({
  type: REMOVE_NOTIFICATION,
  payload: notificationId,
});

export const updateNotificationRead = notificationId => ({
  type: UPDATE_NOTIFICATION_READ,
  payload: notificationId,
});

export const updateAllNotificationsRead = () => ({
  type: UPDATE_ALL_NOTIFICATIONS_READ,
});

export const clearAllNotifications = () => ({
  type: CLEAR_ALL_NOTIFICATIONS,
});
